import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Appuntamento} from "../../models/appuntamento";
import {PrenotazioneAppuntamentoService} from "../../services/prenotazione-appuntamento.service";
import {FormBuilder, Validators} from "@angular/forms";
import {take} from "rxjs";
import {Employee} from "../../models/employee";
import {JoyrideService} from 'ngx-joyride';

import * as L from "leaflet";
import {ServizioErogato} from "../../models/servizio-erogato";
import {AmministrazioneService} from "../../services/amministrazione.service";
import {SubscriptionManager} from "../../shared/subscription-manager/subscription-manager.class";
import {Office} from "../../models/office";
import { ConfigurazioneGeneraleService } from '../../services/configurazione-generale.service';
import { UserData } from '../../models/user-data';

@Component({
  selector: 'jhi-scelta-servizi-prenotazione-admin',
  templateUrl: './scelta-servizi-prenotazione.component.html',
  styleUrls: ['./scelta-servizi-prenotazione.component.scss']
})

export class SceltaServiziPrenotazioneComponent extends SubscriptionManager implements OnInit, AfterViewInit {
  @ViewChild('_SELECT_SERVIZI') _select_servizi!: ElementRef;
  @ViewChild('_SELECT_SEDE') _select_sede!: ElementRef;

  appuntamento!: Appuntamento;
  servErog!: ServizioErogato;
  serviziErogati!: ServizioErogato[];
  circleLoading = false;
  lineLoading = false;
  dipendenti: Employee[] = [];
  codiceServizio: string | null = null;
  ufficio: string | null = null;
  idUfficio: string | null = null;
  map: any;
  indexServizi = 0;
  userData?: UserData;

  private mapZoom = 15;

  initMap(): void {
    this.map = L.map('map', {
      center: [37.56084,14.28296],
      zoom: this.mapZoom
    });

    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18,
      minZoom: 2,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    });

    tiles.addTo(this.map);
  }

  markerIcon = L.icon({
    iconUrl: 'content/images/marker.png',
    iconSize: [30, 30], // size of the icon
    shadowSize: [50, 64], // size of the shadow
    shadowAnchor: [4, 62],  // the same for the shadow
    popupAnchor: [-3, -76] // point from which the popup should open relative to the iconAnchor
  });

  ngAfterViewInit(): void {
    this.initMap();
  }

  formSceltaServizio = this.fb.group({
    nmServizio: ['', [Validators.required]],
    nmUfficio: ['', [Validators.required]],
    nmDipendente: ['', []],
    deNote: ['', []],
  });

  get getNmServizio() {
    return this.formSceltaServizio.controls['nmServizio'];
  };

  get getNmUfficio() {
    return this.formSceltaServizio.controls['nmUfficio'];
  };

  get getNmDipendente() {
    return this.formSceltaServizio.controls['nmDipendente'];
  };

  get getDeNote() {
    return this.formSceltaServizio.controls['deNote'];
  };


  ottieniListaUffici(): Office[] | null {
    if (this.serviziErogati) {
      const idServizioErogato: string | null = this.getNmServizio.value
      for (const servErg of this.serviziErogati) {
        const servizioId: string | undefined = servErg.servizio?.id?.toString();
        if (idServizioErogato == servizioId) {
          if(servErg.uffici){
            return servErg.uffici;
          }else{
            return <Office[]>new Array(servErg.ufficio);
          }
        }
      }
    }
    return null;
  }

  constructor(private joyrideService: JoyrideService, private fb: FormBuilder, private configurazioneGeneraleService: ConfigurazioneGeneraleService, public route: Router, private activatedRoute: ActivatedRoute, public appServ: PrenotazioneAppuntamentoService, private ammServ: AmministrazioneService) {
    super();
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.dipendenti = [];
    this.userData = JSON.parse(<string>localStorage.getItem('userData'));
    this.circleLoading = true;
    this.codiceServizio = this.activatedRoute.snapshot.queryParams["servizio"];
    this.ufficio = this.activatedRoute.snapshot.queryParams["ufficio"];
    if(this.codiceServizio){
      const bodyRequest:any = {
        servizio: {
          codice: this.codiceServizio
        },
        ufficio: {
          id: Number(this.ufficio)
        }
      }
      this.subs.sink = this.appServ.searchAllServizi(bodyRequest).pipe(take(1)).subscribe({
        next: (serv) => {
          this.circleLoading = true;
          this.serviziErogati = serv;
        },
        error: () => {
          void this.route.navigate(['error']);
        },
        complete: () => {
          this.initSceltaServizi();
        }
      });
    }else{
      this.subs.sink = this.appServ.ListaServiziAPI().pipe(take(1)).subscribe({
        next: (serv) => {
          this.circleLoading = true;
          this.serviziErogati = serv;
        },
        error: () => {
          void this.route.navigate(['error']);
        },
        complete: () => {
          this.initSceltaServizi();
        }
      });
    }
    this.getNmUfficio.disable();
    this.getNmDipendente.disable();

    this.subs.sink = this.getNmServizio.valueChanges.subscribe((value) => {
      this.dipendenti = [];
      if (value === '') {
        this.getNmUfficio.setValue('');
        this.getNmUfficio.disable();
        this.getNmDipendente.setValue('');
        this.getNmDipendente.disable();
      } else {
        this.getNmUfficio.setValue('');
        this.getNmUfficio.enable();
        this.getNmDipendente.setValue('');
        this.getNmDipendente.disable();
      }
    });

    this.subs.sink = this.getNmUfficio.valueChanges.subscribe((value) => {
        this.changeValueUfficio(<string>value);
    });
  }

  changeValueUfficio(value: string):void{
    this.dipendenti = [];
    if (value === '') {
      this.getNmDipendente.setValue('');
      this.getNmDipendente.disable();
    } else {
      this.lineLoading = true;

      this.servErog = {
        servizio: {id: this.getNmServizio.value},
        ufficio: <Office>{id: this.getNmUfficio.value}
      }

      const idServizio: string = this.servErog.servizio!.id !== null ? this.servErog.servizio!.id : '0';
      const idUfficio:  string = this.servErog.ufficio!.id  ? this.servErog.ufficio!.id : '0';

      this.subs.sink = this.appServ.listaIdDipendentiPerIDServizioUfficio(idServizio, idUfficio)?.subscribe({
        next: (list) => {
          if (list != undefined) {
            this.servErog.id = list.id;
            this.servErog.listaIdDipendenti = list.listaIdDipendenti;
          }
        },
        complete: () => {
          if (this.servErog.id !== undefined && this.servErog.listaIdDipendenti !== undefined) {
            if (this.getNmServizio.value !== null && this.getNmUfficio.value != null) {
              const ufficio = this.ottieniListaUffici();
              if (ufficio != null) {
                for (const office of ufficio) {
                  if (office.id?.toString() === this.getNmUfficio.value) {
                    this.map.eachLayer((layer: any) => {
                      if (layer instanceof L.Marker) {
                        this.map.removeLayer(layer);
                      }
                    });
                    L.marker([parseFloat(<string>office.sede?.latitudine), parseFloat(<string>office.sede?.longitudine)], {icon: this.markerIcon}).on('click', () => window.open(" https://www.google.com/maps/search/?api=1&query=" + parseFloat(<string>office.sede?.latitudine) + "," + parseFloat(<string>office.sede?.longitudine))).addTo(this.map);
                    this.map.setView([parseFloat(<string>office.sede?.latitudine), parseFloat(<string>office.sede?.longitudine)], this.mapZoom);
                  }
                }
              }
            }

            this.subs.sink = this.ammServ.datiDipendentePerListaID(<string[]>this.servErog.listaIdDipendenti).subscribe({
              next: (listDip) => {
                this.dipendenti = listDip
              },
              complete: () => {
                this.getNmDipendente.setValue('');
                this.getNmDipendente.enable();
                this.lineLoading = false;
              },
              error: () => {
                this.getNmDipendente.setValue('nd')
                this.getNmDipendente.disable();
                this.lineLoading = false;
              }
            });
          } else {
            this.getNmDipendente.setValue('nd')
            this.getNmDipendente.disable();
            this.lineLoading = false;
          }
        },
        error: () => {
          this.getNmDipendente.setValue('nd')
          this.getNmDipendente.disable();
          this.lineLoading = false;
        }
      });
    }

  }

  initSceltaServizi():void{
    if (this.getLocalStorage() != undefined) {
      this.appuntamento = this.getLocalStorage();
      if(this.serviziErogati && this.serviziErogati.length === 1){
        this.getNmServizio.setValue(<string>this.serviziErogati[0].servizio?.id);
        this.servErog = this.serviziErogati[0];
        if(this.serviziErogati[0].ufficio){
          this.getNmUfficio.setValue(<string>this.serviziErogati[0].ufficio?.id?.toString());
        }
      }
      if (this.appuntamento.servizio?.id || this.appuntamento.ufficio?.sede?.id || (this.appuntamento.operatore as Employee | Employee[]) || this.appuntamento.note) {
        this.getNmServizio.setValue(this.appuntamento.servizio!.id);
        this.getNmUfficio.setValue(this.appuntamento.ufficio!.sede!.id);
        this.getDeNote.setValue(<string>this.appuntamento!.note);
        this.servErog = {
          servizio: {id: this.getNmServizio.value},
          ufficio: <Office>{id: this.getNmUfficio.value}
        }
        const idServizio: string = this.servErog.servizio!.id !== null ? this.servErog.servizio!.id : '0';
        const idUfficio: string = this.servErog.ufficio!.id  ? this.servErog.ufficio!.id : '0';

        this.subs.sink = this.appServ.listaIdDipendentiPerIDServizioUfficio(idServizio,idUfficio )?.subscribe({
          next: (list) => {
            this.servErog.id = list.id;
            this.servErog.listaIdDipendenti = list.listaIdDipendenti;
          },
          complete: () => {
            this.subs.sink = this.ammServ.datiDipendentePerListaID(<string[]>this.servErog.listaIdDipendenti).subscribe({
              next: (listDip) => {
                this.dipendenti = listDip
              },
              complete: () => {
                if ((this.appuntamento!.operatore as Employee).id != null || undefined) {
                  this.subs.sink = this.appServ.getOperatore((this.appuntamento!.operatore as Employee).id).subscribe({
                    next: (emp) => {
                      this.getNmDipendente.setValue(emp.id!.toString())
                    }
                  });
                } else {
                  this.getNmDipendente.setValue('');
                }
                this.getNmDipendente.enable();
                this.lineLoading = false;
              },
              error: () => {
                this.getNmDipendente.setValue('nd')
                this.lineLoading = false;
              }
            });
          }
        });
      }
    } else {
      localStorage.removeItem('app');
      void this.route.navigate(['error']);
    }
    this.circleLoading = false;
  }

  onChangeServizio(index: number): void {
    this.indexServizi = index;
    this.formSceltaServizio.controls['nmUfficio'].setValue('');
    this.formSceltaServizio.controls['nmUfficio'].disable();

    if (this.serviziErogati && this.serviziErogati[this.indexServizi]?.uffici) {
      this.formSceltaServizio.controls['nmUfficio'].enable();
    }

    this.dipendenti = [];
    this.getNmDipendente.setValue('');
    this.getNmDipendente.disable();

    // Se necessario, puoi aggiornare la mappa qui in base alla selezione del servizio
    // ...

    this.lineLoading = false;
  }


  getLocalStorage(): Appuntamento {
    return JSON.parse(localStorage.getItem('app') || '{}');
  }

  goToInserimentoDatiPrenotazione(): void {
    if(this.codiceServizio){
      void this.route.navigateByUrl('Appuntamenti/inserimento-dati-prenotazione?servizio='+ this.codiceServizio + "&ufficio=" + <string>this.ufficio, {state: {isListaPrenotazioni: this.checkListaPrenotazioni()}})

    }else{
      void this.route.navigate(['Appuntamenti/inserimento-dati-prenotazione'], {state: {isListaPrenotazioni: this.checkListaPrenotazioni()}})
    }
  }

  checkListaPrenotazioni():boolean{
    return <boolean>window.history.state.isListaPrenotazioni;
  }

  goToListaPrenotazioni():void{
    void this.route.navigate(['Appuntamenti/lista-prenotazioni'], {state: {isListaPrenotazioni: this.checkListaPrenotazioni()}}).then();
  }

  goToNuovoAppuntamento():void{
    if(this.codiceServizio){
      void this.route.navigateByUrl('Appuntamenti/prenota-nuovo-appuntamento?servizio='+ this.codiceServizio + "&ufficio=" + <string>this.ufficio, {state: {isListaPrenotazioni: this.checkListaPrenotazioni()}})
    }else{
      void this.route.navigate(['Appuntamenti/prenota-nuovo-appuntamento'], {state: {isListaPrenotazioni: this.checkListaPrenotazioni()}});
    }
  }

  goToHome():void{
    window.location.href = this.configurazioneGeneraleService.configurazione.linkHome;
  }

  goToInserimentoDataOra(): void {
    if(this.codiceServizio){
      this.getNmServizio.markAsDirty();
    }
    if (this.formSceltaServizio.valid && (this.appuntamento != null || this.appuntamento != undefined)) {
      if (this.getNmServizio.dirty || this.getNmUfficio.dirty || this.getNmDipendente.dirty) {
        this!.appuntamento.servizio = {
          id: this.getNmServizio.value,
          nmServizio: new Array(...this._select_servizi.nativeElement.options).find((option: {
            value: any;
          }) => option.value === this.getNmServizio.value)?.text
        };
        this!.appuntamento.ufficio = {
          sede: {
            id: this.getNmUfficio.value,
            dlIndirizzo: new Array(...this._select_sede.nativeElement.options).find((option: {
              value: any;
            }) => option.value === this.getNmUfficio.value)?.text
          }
        };
        this!.appuntamento.note = this.getDeNote.value;

        this!.appuntamento.idServizioErogato = this.servErog.id;
        this!.appuntamento.dataApp = undefined;
        this!.appuntamento.oraInizio = undefined;
        this!.appuntamento.oraFine = undefined;

        if (this.getNmDipendente.value == '') {
          (this!.appuntamento.operatore as Employee[]) = this.dipendenti;
          this!.appuntamento.flScelto = 'N';
        } else {
          this!.appuntamento.flScelto = 'S';
          (this!.appuntamento.operatore as Employee) = ({id: parseInt(<string>this.getNmDipendente.value)})
        }

      }

      localStorage.setItem('app', JSON.stringify(this.appuntamento));
      if(this.codiceServizio){
        void this.route.navigateByUrl('Appuntamenti/scelta-data-ora-prenotazione?servizio=' + this.codiceServizio + "&ufficio=" + <string>this.ufficio, {state: {isListaPrenotazioni: this.checkListaPrenotazioni()}})
      }else{
        void this.route.navigate(['Appuntamenti/scelta-data-ora-prenotazione'], {state: {isListaPrenotazioni: this.checkListaPrenotazioni()}})
      }
    }

  }

  onTour(): any {
    this.joyrideService.startTour({
      steps: ['primoStep', 'secondoStep', 'terzoStep', 'quartoStep', 'quintoStep', 'sestoStep']
    })
  }
}
